import { SIZE_PRESETS, createSize } from "./sizes";

/** A4 landscape in CSS px; what every HTML certificate used before page sizes. */
export const DEFAULT_PAGE_SIZE = Object.freeze({ width: 1123, height: 794 });

const PAGE_RULE = /\.cf-page\{width:(\d+(?:\.\d+)?)px;height:(\d+(?:\.\d+)?)px/;
const ASPECT_TOLERANCE = 0.02;

export function readHtmlPageSize(html) {
  const match = String(html || "").match(PAGE_RULE);
  if (!match) return null;
  const width = Number(match[1]);
  const height = Number(match[2]);
  return width > 0 && height > 0 ? { width, height } : null;
}

export function pageSizeFromAspect(width, height) {
  if (!(width > 0 && height > 0)) return null;
  const aspect = width / height;
  let best = null;
  Object.keys(SIZE_PRESETS).forEach((id) => {
    const { widthPx, heightPx } = createSize(id);
    const diff = Math.abs(widthPx / heightPx - aspect) / aspect;
    if (diff <= ASPECT_TOLERANCE && (!best || diff < best.diff)) {
      best = { diff, width: widthPx, height: heightPx };
    }
  });
  if (best) return { width: best.width, height: best.height };
  const longSide = DEFAULT_PAGE_SIZE.width;
  return aspect >= 1
    ? { width: longSide, height: Math.round(longSide / aspect) }
    : { width: Math.round(longSide * aspect), height: longSide };
}
